export default __webpack_public_path__ + "static/media/trialMessageBanner.65fada59.png";